module.exports = __webpack_public_path__ + "img/aboutUs_img16.62654864.svg";